import * as Turbo from "@hotwired/turbo";
import { bindToggles, preserveScroll } from "../components/nav";
import { initToc } from "../components/toc";
import { attachCopyToClipboardButton } from "../components/copyToClipboardButton";
import { themeToggle } from "../components/themeToggle";
import { initPageCopyDropdown } from "../components/pageCopyDropdown";
import { initPlainChat } from "../components/plainChat";
import { initSecurityChecklist } from "../components/securityChecklist";
import { initAnimations } from "../components/animations";
import docsearch from "@docsearch/js";
import {
  initSearchTracking,
  searchTrackingClient,
  searchTrackingItems,
  searchTrackingNavigator,
} from "../components/searchTracking";
import { initMarketingAttribution } from "../components/marketingAttribution";

Turbo.start();

// Store cleanup functions for proper memory management
let cleanupFunctions = [];

document.addEventListener("turbo:render", async (event) => {
  cleanup();
  render();
});

window.addEventListener("DOMContentLoaded", () => {
  render();
});

function cleanup() {
  // Call all cleanup functions from previous renders
  cleanupFunctions.forEach((fn) => {
    if (typeof fn === "function") {
      try {
        fn();
      } catch (error) {
        console.warn("Error during cleanup:", error);
      }
    }
  });
  cleanupFunctions = [];
}

function getCurrentSection() {
  const match = window.location.pathname.match(/^\/docs\/([^/]+)/);
  return match ? match[1] : null;
}

const relatedSections = {
  "package-registries": ["pipelines", "platform"],
  "test-engine": ["pipelines", "agent"],
  pipelines: ["agent", "platform"],
  agent: ["pipelines", "platform"],
  platform: ["pipelines", "agent"],
  apis: ["pipelines", "platform"],
};

function render() {
  initMarketingAttribution();

  const section = getCurrentSection();
  const optionalFilters = [];
  if (section) {
    optionalFilters.push(`tags:${section}<score=2>`);
    (relatedSections[section] || []).forEach((s) =>
      optionalFilters.push(`tags:${s}<score=1>`),
    );
  }
  const searchParameters = { optionalFilters, hitsPerPage: 40 };

  docsearch({
    container: "#search",
    appId: __ALGOLIA_APP_ID__,
    apiKey: __ALGOLIA_API_KEY__,
    indexName: __ALGOLIA_INDEX_NAME__,
    searchParameters,
    transformSearchClient: searchTrackingClient,
    transformItems: searchTrackingItems,
    navigator: searchTrackingNavigator,
  });

  bindToggles();
  preserveScroll();
  const checklistCleanup = initSecurityChecklist();
  if (checklistCleanup) cleanupFunctions.push(checklistCleanup);
  const animationsCleanup = initAnimations();
  if (animationsCleanup) cleanupFunctions.push(animationsCleanup);
  initToc();
  attachCopyToClipboardButton("pre.highlight");
  themeToggle();
  initPlainChat();

  // Store cleanup function if component returns one
  const dropdownCleanup = initPageCopyDropdown();
  if (dropdownCleanup) {
    cleanupFunctions.push(dropdownCleanup);
  }

  const searchTrackingCleanup = initSearchTracking();
  if (searchTrackingCleanup) {
    cleanupFunctions.push(searchTrackingCleanup);
  }
}

window.addEventListener("DOMContentLoaded", () => {
  document.onkeydown = (e) => {
    const event = window.event || e;

    switch (event.keyCode) {
      case 191:
        if (
          ["INPUT", "TEXTAREA", "SELECT"].includes(
            document.activeElement.tagName,
          )
        )
          break;
        e.preventDefault();
        document.getElementById("search").focus();
        break;
    }
  };
});
